module.exports = __webpack_public_path__ + "static/media/img-manner-baggage.af287fe6.svg";